import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import RichTextEditor from 'react-rte';
import { Editor, EditorState, CompositeDecorator, ContentState, Modifier } from 'draft-js';

const useStyles = makeStyles((theme) => ({
    input: {
        backgroundColor: "#FCFCFC",
        boxSizing: "border-box",
        borderRadius: "2px",
        marginBottom: "10px"
    },
}));

// const toolbarConfig = {
//     // Optionally specify the groups to display (displayed in the order listed).
//     display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
//     INLINE_STYLE_BUTTONS: [
//       {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
//       {label: 'Italic', style: 'ITALIC'},
//       {label: 'Underline', style: 'UNDERLINE'}
//     ],
//     BLOCK_TYPE_DROPDOWN: [
//       {label: 'Normal', style: 'unstyled'},
//       {label: 'Heading Large', style: 'header-one'},
//       {label: 'Heading Medium', style: 'header-two'},
//       {label: 'Heading Small', style: 'header-three'}
//     ],
//     BLOCK_TYPE_BUTTONS: [
//       {label: 'UL', style: 'unordered-list-item'},
//       {label: 'OL', style: 'ordered-list-item'}
//     ]
//   };

const StepOne = (props) => {
    const [editorState, setEditorState] = useState(props.publishDetail.publish_detail["short_description"] ?
        RichTextEditor.createValueFromString(props.publishDetail.publish_detail["short_description"].toString("html"), "html") :
        RichTextEditor.createEmptyValue())
    const classes = useStyles();
    const { t } = useTranslation();
    const [processName, setProcessName] = useState(props.publishDetail.publish_detail["name"]);


    const handleChange = () => {
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                name: processName,
            }
        }))
    }

    const handleEdit = value => {
        setEditorState(value)
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                short_description: value
            }
        }))
    }

    useEffect(() => {
        if (props.publishDetail.publish_detail.type === "library" && props.libraryDetail.library) {
            setProcessName(props.libraryDetail?.library?.library_name);
        }
    }, []);

    useEffect(() => {
        let valHtml = editorState.toString('html').replace(/(<([^>]+)>)/gi, "").trim()
        if (processName.length > 0 && valHtml.length > 0) {
            props.setIsRequired(false)
        } else {
            props.setIsRequired(true)
        }
    }, [editorState, processName])

    return (
        <DialogContent style={{ padding: "20px 0 0 0" }}>
            <div>
                <Grid container>
                    <Grid item xs={12}>

                        <span className="dialog-text">
                            {props.publishDetail.publish_detail.type === 'library' ? "Library " : props.publishDetail.publish_detail.type === "bot" ? "Bot " : "Action "}
                            {t('CONTENT.PUBLISH.PROCESS-NAME')}&nbsp;
                            <span
                                style={{
                                    color: "#c67575",
                                    fontSize: "9px"
                                }}>({t('CONTENT.PUBLISH.THIS-FIELD-NOT-CHANGEABLE')})</span></span>
                    </Grid>
                    {props.publishDetail.publish_detail.type === 'library' ? (
                        <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                            <TextField
                                id="filled-size-small"
                                required
                                value={processName}
                                className={classes.input}
                                variant="outlined"
                                size="small"
                                disabled={true}
                                aria-readonly={true}
                                fullWidth
                                inputProps={{ style: { fontSize: 12, fontWeight: "bold" } }}
                            />
                        </Grid>
                    ) : (
                        <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                            <TextField
                                id="filled-size-small"
                                required
                                disabled={props.publishDetail.publish_detail.publish_type === "update" || props.publishDetail.publish_detail.status === "current_action"}
                                value={processName}
                                onBlur={() => handleChange()}
                                onChange={(e) => {
                                    if ((props.publishDetail.publish_detail.status === "new_action") || props.publishDetail.publish_detail.publish_type === "new") {
                                        setProcessName(e.target.value);
                                    }
                                }}
                                className={classes.input}
                                variant="outlined"
                                size="small"
                                fullWidth
                                inputProps={{ style: { fontSize: 12 } }}
                            />
                        </Grid>
                    )
                    }

                    <Grid item xs={3}>
                        <span className="dialog-text">{t('CONTENT.PUBLISH.SHORT-DESC')}</span>
                    </Grid>
                </Grid>
            </div>
            <RichTextEditor
                value={editorState}
                editorClassName="publish-editor"
                onChange={value => handleEdit(value)}
            // toolbarConfig={toolbarConfig}
            />
        </DialogContent>
    );
};

export default StepOne;
